import { createSlice } from "@reduxjs/toolkit";

export const appointmentSlice = createSlice({
  name: "appointment",
  initialState: {
    appointments: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    getAppointmentStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getAppointmentSuccess: (state, action) => {
      state.isFetching = false;
      state.appointments = action.payload;
    },
    getAppointmentFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    // UPDATE
    updateAppointmentStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    updateAppointmentSuccess: (state, action) => {
      console.log(action.payload, 'payload in service')
      state.isFetching = false;
      state.appointments[
        state.appointments.findIndex((item) => item._id === action.payload.id)
      ] = action.payload.category;
    },
    updateAppointmentFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const {
  getAppointmentStart,
  getAppointmentSuccess,
  getAppointmentFailure,
  updateAppointmentStart,
  updateAppointmentSuccess,
  updateAppointmentFailure,
} = appointmentSlice.actions;

export default appointmentSlice.reducer;
